import {StatusGroupType} from '../../../../../models/mongoose/StatusModel/enum/StatusGroupType'
import {StatusGroupPresentationMap} from '../../../maps/StatusGroupPresentationMap'
import {IGroupFilter} from '../../../types/IGroupFIlter'

export interface IStatusGroupBucket {
  groupType: StatusGroupType
  statusIds: string[]
  excludedStatusIds?: string[]
}

export interface IStatusGroupBucketingContext {
  statusIdsByGroupType: Map<StatusGroupType, string[]>
  namedGroupStatusIds: string[]
}

export function resolveStatusGroupType(groupType: unknown): StatusGroupType {
  return StatusGroupPresentationMap.has(groupType as StatusGroupType)
    ? groupType as StatusGroupType
    : StatusGroupType.Other
}

export function isStatusGroupBucket(value: unknown): value is IStatusGroupBucket {
  if(!value || typeof value !== 'object' || Array.isArray(value)) {
    return false
  }
  const bucket = value as Partial<IStatusGroupBucket>
  return typeof bucket.groupType === 'string' && Array.isArray(bucket.statusIds)
}

export function buildStatusGroupBucketExpression(
  valuePath: string,
  statusIds: string[],
  groupTypes: StatusGroupType[],
): Record<string, unknown> {
  return {
    $let: {
      vars: {
        idx: {
          $indexOfArray: [statusIds, valuePath],
        },
      },
      in: {
        $cond: [
          {
            $or: [
              {$eq: [valuePath, null]},
              {$eq: [{$type: valuePath}, 'missing']},
            ],
          },
          null,
          {
            $cond: [
              {$lt: ['$$idx', 0]},
              StatusGroupType.Other,
              {$arrayElemAt: [groupTypes, '$$idx']},
            ],
          },
        ],
      },
    },
  }
}

export function buildStatusGroupBucketFilter(valuePath: string, bucket: IStatusGroupBucket): IGroupFilter {
  if(bucket.groupType !== StatusGroupType.Other || !Array.isArray(bucket.excludedStatusIds)) {
    return {[valuePath]: {$in: bucket.statusIds}}
  }
  return {
    [valuePath]: {
      $ne: null,
      $nin: bucket.excludedStatusIds,
    },
  }
}
